export default __webpack_public_path__ + "840c965efe502ed94fbcc6a4ca35d44e.svg";